import { FormattedMessage, useIntl } from 'react-intl';
import { PoolConfirmationModal, PoolFormattedMessage } from '@synergy/components-next';

interface DemandSubmitModalProps {
    open: boolean;
    demandTitle: string;
    endDate?: Date;
    onConfirm: () => void;
    onCancel: () => void;
}

export const DemandSubmitModal = ({ open, demandTitle, endDate, onCancel, onConfirm }: DemandSubmitModalProps) => {
    const intl = useIntl();

    return (
        <PoolConfirmationModal
            open={open}
            title={<FormattedMessage id="app.demands.detail.submit" />}
            action={<FormattedMessage id="app.demands.detail.submit.short" />}
            onCancel={onCancel}
            onConfirm={onConfirm}
            isSuccessDialog={true}
        >
            <PoolFormattedMessage
                id="app.demands.detail.submitText"
                values={{
                    title: demandTitle,
                    date: intl.formatDate(endDate, {
                        day: '2-digit',
                        month: 'long',
                        year: 'numeric',
                    }),
                }}
            />
        </PoolConfirmationModal>
    );
};
